import './DirectMailerLog.scss';
import {
    CalculationsLogServiceName,
    CUSTOMER_DETAILS_SERVICE_NAME,
    DirectMailerLogsServiceName,
    ToastNotificationServiceName
} from "../../../utils/names/serviceNames";
import {IComponentController, IHttpPromise, ILocationService, IOnChangesObject, IScope} from "angular";
import {CustomerDetailsService} from "../../../customer_service/service/CustomerDetailService";
import {Pageable} from "../../../utils/models/Page";
import {DirectMailerLogDTO} from "../../model/DirectMailerLogDTO";
import {
    CustomerOpportunityDialog
} from "../../../opportunities/component/customerOpportunityDialog/CustomerOpportunityDialog";
import {CalculationsLogService} from "../../../logging_lqb_funded/services/CalculationsLogService";
import {DirectMailerLogsService} from "../../service/DirectMailerLogsService";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {ActionStatus} from "../../../action_status/model/ActionStatus";


export interface DirectMailerLogScope extends IScope {
    getExecutionDuration: (l: DirectMailerLogDTO) => string;
    navigateTo: (customerId: number) => void;
    logs: DirectMailerLogDTO[];
    logPromise: IHttpPromise<any>;
    fetchLog: () => void;
    pagingConfig: Pageable;
    openOpportunityModal: ($event, directMailerLogDTO) => void;
    resendComplianceLetter: (opportunityId) => void;
}

export class DirectMailerLog implements IComponentController {

    static instance = {
        controller: [
            '$scope',
            '$location',
            DirectMailerLogsServiceName,
            ToastNotificationServiceName,
            CUSTOMER_DETAILS_SERVICE_NAME,
            '$mdDialog',
            CalculationsLogServiceName,
            DirectMailerLog
        ],
        template: require('./DirectMailerLog.html'),
        bindings: {
            pagingConfig: '<',
            logs: '<',
            fetchLogs: '<'
        }
    };

    private $mdDialog: angular.material.IDialogService;
    private $scope: DirectMailerLogScope;
    private pagingConfig: Pageable;
    private logs: DirectMailerLogDTO[];
    private fetchLogs: () => void;
    private $location: ILocationService;
    private loggingService: CalculationsLogService;
    private directMailerLoggingService: DirectMailerLogsService;
    private toastNotificationService: ToastNotificationService;


    constructor($scope: DirectMailerLogScope,
                $location: ILocationService,
                directMailerLoggingService: DirectMailerLogsService,
                toastNotificationService: ToastNotificationService,
                CustomerDetailService: CustomerDetailsService,
                $mdDialog: angular.material.IDialogService,
                loggingService: CalculationsLogService) {
        this.directMailerLoggingService = directMailerLoggingService;
        this.toastNotificationService = toastNotificationService;
        $scope.navigateTo = this.navigateTo;
        $scope.getExecutionDuration = this.getExecutionDuration;
        this.loggingService = loggingService;
        this.$mdDialog = $mdDialog;

        $scope.resendComplianceLetter = this.resendComplianceLetter;
        $scope.openOpportunityModal = this.openOpportunityModal;
        this.$scope = $scope;
        this.$location = $location;
    }

    $onInit = () => {
        let $scope = this.$scope;
        $scope.logs = this.logs;
        $scope.fetchLog = this.fetchLogs;
        $scope.pagingConfig = this.pagingConfig;
    };

    resendComplianceLetter = (opportunityId: number) => {
        this.directMailerLoggingService.resend(opportunityId).then(resp => {
            if (resp.status === 200 && resp.data.status !== ActionStatus.REJECTED) {
                this.toastNotificationService.generateSuccessMessage('Compliance mail was resent');
            } else {
                this.toastNotificationService.generateErrorMessage('Compliance letter was not resent');
            }
            this.fetchLogs();
        });
    }

    openOpportunityModal = ($event, directMailerLogDTO: DirectMailerLogDTO) => {
        this.loggingService.getOpportunityDetails(directMailerLogDTO.opportunityId)
            .then(resp => {
                let opportunity = resp.data;
                this.$mdDialog.show(CustomerOpportunityDialog.instance($event, opportunity, true, true));
            })
    };

    navigateTo = (customerId: number) => {
        this.$location.url(`/contact_profile/${customerId}`);
    };

    $onChanges(onChangesObj: IOnChangesObject): void {
        this.listenToPropCahnges(onChangesObj, 'logs', (logs: DirectMailerLogDTO[]) => this.$scope.logs = logs);
        this.listenToPropCahnges(onChangesObj, 'pagingConfig', (pagingConfig: Pageable) => this.$scope.pagingConfig = pagingConfig);
    }

    getExecutionDuration = (l: DirectMailerLogDTO): string => {
        let finished = new Date(l.finishedExecution);
        let started = new Date(l.startedExecution);
        return (finished.getTime() - started.getTime()) / 1000.0 + 's'
    };

    private listenToPropCahnges<T>(onChangesObj: IOnChangesObject, propName: string, callback: (change: T) => void) {
        var popChange = onChangesObj[propName];
        if (popChange && !popChange.isFirstChange()) {
            callback(popChange.currentValue);
        }
    }
}